// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

:host ::ng-deep .swiper .swiper-slide {
  flex-direction: column;
}

swiper {
  height: 100%;
}
swiper .caption {
  color: white;
  padding: 8px;
}

#background-content {
  background-color: black;
}

.custom-chip {
  font-size: 18px;
  color: #428cff;
}

.visit-item-header-buttons {
  position: relative;
  z-index: 3;
  margin-bottom: -60px;
  padding: 10px;
  background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.4));
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
}
.visit-item-header-buttons ion-chip.white-chip {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.87);
}
.visit-item-header-buttons ion-chip.white-chip ion-icon {
  color: rgba(255, 255, 255, 0.87);
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-viewer-activity/modal-viewer-activity.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;AACI;EACI,YAAA;EACA,YAAA;AACR;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACE,eAAA;EACA,cAAA;AAAF;;AAGA;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,oEAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AAAJ;AAEI;EACE,qCAAA;EACA,gCAAA;AAAN;AAEM;EACE,gCAAA;AAAR","sourcesContent":["ion-content {\r\n    --background: transparent;\r\n}\r\n\r\n:host ::ng-deep .swiper .swiper-slide {\r\n    flex-direction: column;\r\n}\r\n\r\nswiper {\r\n    height: 100%;\r\n\r\n    .caption {\r\n        color: white;\r\n        padding: 8px;\r\n    }\r\n}\r\n\r\n#background-content {\r\n    background-color: black;\r\n}\r\n\r\n.custom-chip {\r\n  font-size: 18px;\r\n  color: #428cff;\r\n}\r\n\r\n.visit-item-header-buttons {\r\n    position: relative;\r\n    z-index: 3;\r\n    margin-bottom: -60px;\r\n    padding: 10px;\r\n    background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.4));\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    width: 100%;\r\n\r\n    ion-chip.white-chip {\r\n      background: rgba(white, 0.12);\r\n      color: rgba(white, 0.87);\r\n  \r\n      & ion-icon {\r\n        color: rgba(white, 0.87);\r\n      }\r\n    }\r\n  \r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
